import { DYNAMIC_QUESTION_TYPE } from 'app-constants';
import { getDefaultFieldSize } from '../../helper';

export const validateDroppedItem = ({ droppedItem, ref, clientOffset, scale }) => {
  const dropTargetXy = ref.current.getBoundingClientRect();

  const type: DYNAMIC_QUESTION_TYPE = (droppedItem as any).type;
  const { width, height } = getDefaultFieldSize(type, scale);

  const x = (clientOffset.x - dropTargetXy.left - width / 2) / scale;
  const y = (clientOffset.y - dropTargetXy.top - height / 2) / scale;

  const fieldX = x * scale;
  const fieldY = y * scale;

  const isOverflowX = fieldX < 0 || width + fieldX > dropTargetXy.width;
  const isOverflowY = fieldY < 0 || height + fieldY > dropTargetXy.height;

  if (isOverflowX || isOverflowY) {
    return { isInvalid: true, width: 0, height: 0 };
  }

  return { x, y, width, height, type, isInvalid: false };
};

export const isSignatureField = (type) =>
  type === DYNAMIC_QUESTION_TYPE.Signature || type === DYNAMIC_QUESTION_TYPE.Initials;

export const isStrikethroughField = (type) => type === DYNAMIC_QUESTION_TYPE.StrikeThrough;

export const isGroupField = (type) => type === DYNAMIC_QUESTION_TYPE.RadioGroup;
